import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import styles from './logo.module.scss';
import { config } from '../../../../api/config';
import { getLandingPathForRole } from '../../../../utils';
import logo from './h2auto_logo.svg';

const Logo = ({ isImpersonating, role }) => (
  <Link
    to={
      isImpersonating
        ? config.APP_PATHS.baEmployees
        : getLandingPathForRole(
            role,
            config.APP_PATHS.home,
            config.APP_PATHS.baEmployees
          )
    }
  >
    <img className={styles.logo} src={logo} alt="H2AUTO" />
  </Link>
);

Logo.propTypes = {
  isImpersonating: PropTypes.bool.isRequired,
  role: PropTypes.number,
};

const mapStateToProps = state => ({
  isImpersonating: state.auth.isImpersonating,
  role: state.auth.user?.role,
});

export default connect(mapStateToProps)(Logo);
